export default __webpack_public_path__ + "static/media/1790.ea0c61d0.png";